export default "__VITE_ASSET__CoJRATqL__"